<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Nro</th>
              <th scope="col" class="text-center">Evento</th>
              <th scope="col" class="text-center">Detalle</th>
              <th scope="col" class="text-center">Modalidad</th>
              <th scope="col" class="text-center">Estado</th>
              <th scope="col" class="text-center">Acción</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="paginatedItems.length > 0">
              <tr v-for="(item, index) in paginatedItems" :key="item.id">
                <!-- <th scope="row">{{ item.id }}</th> -->
                <th scope="row">
                  {{ (currentPage - 1) * itemsPerPage + index + 1 }}
                </th>
                <td class="text-center" style="max-width: 250px">
                  {{ item.title }}
                </td>
                <td class="text-center">{{ item.description }}</td>
                <td class="text-center">
                  {{ item.modality.name }}
                </td>
                <td class="text-center">
                  <span
                    v-if="item.inbox === 0"
                    class="badge bg-secondary btn-sm p-2"
                  >
                    <i class="fa fa-clock-o"></i> Borrador
                  </span>
                  <span
                    v-else-if="item.inbox === 1"
                    class="badge btn-sm p-2"
                    style="background-color: #8754ff"
                  >
                    <i class="fa fa-paper-plane"></i> Enviado
                  </span>
                  <span
                    v-else-if="item.inbox === 2"
                    class="badge bg-warning btn-sm p-2"
                  >
                    <i class="fa fa-hourglass-half"></i> En Revisión
                  </span>
                  <span
                    v-else-if="item.inbox === 3"
                    class="badge bg-success btn-sm p-2"
                  >
                    <i class="fa fa-check"></i> Aprobado
                  </span>
                  <span
                    v-else-if="item.inbox === 4"
                    class="badge bg-info btn-sm p-2"
                  >
                    <i class="fa fa-exclamation-triangle"></i> Observado
                  </span>
                  <span
                    v-else-if="item.inbox === 5"
                    class="badge bg-danger btn-sm p-2"
                  >
                    <i class="fa fa-times"></i> Rechazado
                  </span>
                </td>
                <td class="text-center">
                  <div v-if="item.inbox === 0">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="openEditModal(item)"
                        title="Editar el evento"
                        :disabled="item.inbox != 0"
                      >
                        <i class="fa fa-edit"></i> Editar
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="changeState(item)"
                        title="Enviar el evento a comunicación"
                        :disabled="item.inbox != 0"
                      >
                        <i class="fa fa-send"></i> Enviar
                      </button>
                    </div>
                  </div>
                  <div v-else-if="item.inbox === 4">
                    <div class="btn-group">
                      <button
                        class="btn btn-info"
                        @click="showObservation(item)"
                        title="Ver motivo de observación"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                      <button
                        class="btn btn-secondary"
                        @click="openEditModal(item)"
                        title="Realizar las correcciones"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <button
                        class="btn btn-primary"
                        @click="resendEvent(item)"
                        title="Volver a enviar el evento"
                      >
                        <i class="fa fa-send"></i>
                      </button>
                    </div>
                  </div>
                  <div v-else-if="item.inbox === 5">
                    <div class="btn-group">
                      <button
                        class="btn btn-danger"
                        @click="showRejection(item)"
                        title="Ver motivo de rechazo"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                    </div>
                  </div>
                  <span v-else class="text-muted">
                    <i class="fa fa-info-circle"></i> Sin acciones
                  </span>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="text-center py-4 text-muted">
                <EmptyState
                  title="No tiene eventos creados."
                  :size="450"
                  fontSize="fs-5"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="props.list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>

  <ObservationModal
    ref="observationModal"
    :event="selectedEvent"
    @acknowledged="handleObservationAcknowledged"
  />

  <RejectionModal
    ref="rejectionModal"
    :event="selectedEvent"
    @acknowledged="handleRejectionAcknowledged"
  />
  <ModalEditEvent
    ref="editModal"
    :eventData="selectedEvent"
    @updated="emit('reloadList')"
  />
</template>

<script setup>
import { ref, computed, inject } from "vue";
import Pagination from "@/pages/components/Pagination.vue";
import ObservationModal from "../components/EventModalObserved.vue";
import RejectionModal from "../components/EventModalRejected.vue";
import ModalEditEvent from "../components/ModalUpdate.vue";
import EmptyState from "@/components/emptyState.vue";
import { validarDiaHabil } from "@/utils/businessDays.js";

const editModal = ref(null);
const swal = inject("$swal");

function openEditModal(item) {
  selectedEvent.value = item;
  editModal.value?.showModal();
}

import connection from "@/includes/connection";
import { toast } from "vue3-toastify";

const props = defineProps({ list: Array });
const emit = defineEmits(["reloadList"]);

const observationModal = ref(null);
const rejectionModal = ref(null);
const selectedEvent = ref({});

const list = computed(() => {
  return props.list;
});

const userId = localStorage.getItem("userId");

const changeState = (item) => {
  const initInc = new Date(item.init_date_inscription);
  const validHabilDay = validarDiaHabil(initInc);

  if (!validHabilDay.isValid) {
    swal.fire({
      title: "Advertencia de días hábiles",
      text: validHabilDay.mensaje,
      icon: "error",
      confirmButtonText: "Entendido",
    });
    return;
  }

  swal
    .fire({
      title: "Confirmar Envío",
      text: "¿Está seguro de enviar este evento a comunicación?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sí, enviar",
      focusCancel: true,
      reverseButtons: true,
    })
    .then((result) => {
      if (result.isConfirmed) {
        connection
          .patch("/event/" + item.id)
          .then((response) => {
            console.log("change state");
            toast.success("Operación exitosa, Evento enviado a comunicación.");
            emit("reloadList");
          })
          .catch(function (error) {
            toast.error("Operación fallida, verifique el estado del evento.");
            console.log("change error", error);
            emit("reloadList");
          });
      }
    });
};

const resendEvent = (item) => {
  const initInc = new Date(item.init_date_inscription);
  const validHabilDay = validarDiaHabil(initInc);

  if (!validHabilDay.isValid) {
    swal.fire({
      title: "Advertencia de días hábiles",
      text: validHabilDay.mensaje,
      icon: "error",
      confirmButtonText: "Entendido",
    });
    return;
  }

  swal
    .fire({
      title: "Confirmar Reenvío",
      text: "¿Está seguro de reenviar este evento a comunicación? Se reiniciará el proceso de aprobación.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sí, reenviar",
      focusCancel: true,
      reverseButtons: true,
    })
    .then((result) => {
      if (result.isConfirmed) {
        connection
          .patch("/event/" + item.id + "/resend", { userId: userId })
          .then((response) => {
            console.log("resend event");
            toast.success("Evento reenviado exitosamente a comunicación.");
            emit("reloadList");
          })
          .catch(function (error) {
            console.log("resend error", error);
            toast.error("Error al reenviar el evento. Verifique el estado.");
            emit("reloadList");
          });
      }
    });
};

const showObservation = (item) => {
  selectedEvent.value = item;
  observationModal.value.show();
};

const showRejection = (item) => {
  selectedEvent.value = item;
  rejectionModal.value.show();
};

const handleObservationAcknowledged = (event) => {
  //console.log("Observación reconocida para evento:", event.id);
  toast.info(
    "Observación revisada. Puede realizar las correcciones necesarias."
  );
};

const handleRejectionAcknowledged = (event) => {
  //console.log("Rechazo reconocido para evento:", event.id);
  toast.info(
    "Rechazo revisado. Puede crear un nuevo evento con las correcciones."
  );
};

let currentPage = ref(1);
let itemsPerPage = ref(10);

const sortedList = computed(() => {
  return [...props.list].sort((a, b) => b.id - a.id);
});

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  //return props.list.slice(startIndex, endIndex);
  return sortedList.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
